/* src/main/webapp/app/components/dashboard-wrapper/dashboard-wrapper.component.scss */
.dashboard-scroll-container {
  height: calc(100vh - 120px);
  overflow: auto;
  padding: 1rem;
}
:host {
  display: block;
}
/*# sourceMappingURL=dashboard-wrapper.component-CQQCN323.css.map */
